export default __webpack_public_path__ + "static/media/cp_geo_gd.d1128053.svg";